// Note:  this file defines enumerations used
//        by scheduled event model classes.

export enum ScheduledEventObjectType {
    AsynchJob = 'asyncJob',
    DataCollection = 'dataCollection',
    Dummy = 'Dummy', // Used by the scheduled event service.
    Folder = 'folder',
    Form = 'form',
    FormInstance = 'formInstance',
    MagicStructure = 'magicStructure',
    Notification = 'notification'
};

export enum ScheduledAction {
    Dummy = 'Dummy', // Used in class DummyScheduledEvent in file scheduled-event.service.ts.

    SetWorkflowState = 'SetWorkflowState',
    SendNotification = 'SendNotification'
};
